import { fmt, plans } from '../../lib/geo'
import { PLAN_ICON } from '../../lib/content'
import { ActivityIcon } from '../ui/Icon'
import './Ribbon.css'

function Row({ list, reverse }: { list: typeof plans; reverse?: boolean }) {
  // The list is rendered twice so the loop is seamless; the copy is hidden from screen readers.
  return (
    <div className={`track${reverse ? ' rev' : ''}`}>
      {[0, 1].map((copy) =>
        list.map((p) => (
          <span key={`${copy}-${p.id}`} className="rchip glass thin" aria-hidden={copy === 1 || undefined}>
            <span className="ico"><ActivityIcon name={PLAN_ICON[p.id] ?? 'chai'} /></span>
            {p.title}<span>{fmt(p.start)}</span>
          </span>
        )),
      )}
    </div>
  )
}

export function Ribbon() {
  return (
    <div className="ribbon" aria-label="Example plans people post on mauj">
      <Row list={plans.slice(0, 12)} />
      <Row list={plans.slice(12)} reverse />
    </div>
  )
}
